import { useState } from "react";
import { Mic, Music2, Sparkles, UploadCloud } from "lucide-react";
import TrainingMeter from "@/components/myvoices/TrainingMeter";
import ClipList from "@/components/myvoices/ClipList";
import UploadClipDialog from "@/components/myvoices/UploadClipDialog";
import PickSourceDialog from "@/components/myvoices/PickSourceDialog";

const btn = "inline-flex items-center gap-2 rounded-full border border-white/12 bg-white/[0.05] px-3.5 py-2 text-[12px] font-medium text-white/85 transition-colors hover:bg-white/[0.12]";

/** Section 1 — what the model learns from. */
export default function TrainingSet({ voice, clips, status, onChanged }) {
  const [dialog, setDialog] = useState(null);
  return (
    <section data-testid="training-set" className="rounded-3xl border border-white/[0.08] bg-[#0a0d1c]/80 p-5 sm:p-6">
      <h2 className="flex items-center gap-2 font-display text-base font-semibold md:text-lg"><Mic className="h-4 w-4 text-cyan-300" /> Training recordings</h2>
      <div className="mt-4"><TrainingMeter seconds={voice.singing_sec} status={status} /></div>
      <div className="mt-5 flex flex-wrap gap-2">
        <button type="button" data-testid="add-clip-upload" className={btn} onClick={() => setDialog("upload")}><UploadCloud className="h-4 w-4 text-cyan-300" /> Upload recordings</button>
        <button type="button" data-testid="add-clip-enhance" className={btn} onClick={() => setDialog("enhance")}><Sparkles className="h-4 w-4 text-amber-300" /> From Enhanced Vocals</button>
        <button type="button" data-testid="add-clip-take" className={btn} onClick={() => setDialog("take")}><Music2 className="h-4 w-4 text-rose-300" /> From studio takes</button>
      </div>
      <div className="mt-3"><ClipList voiceId={voice.id} clips={clips} onChanged={onChanged} /></div>
      <UploadClipDialog open={dialog === "upload"} onClose={() => setDialog(null)} voiceId={voice.id} onAdded={onChanged} />
      <PickSourceDialog open={dialog === "enhance" || dialog === "take"} kind={dialog} onClose={() => setDialog(null)} voiceId={voice.id} onAdded={onChanged} />
    </section>
  );
}
